/**
 * JOMarquee — Two opposing tilted scrolling marquees, premium magazine feel.
 * NON-CORE FILE — additive customization.
 */
import React from "react";
import { Sparkles, Sprout, TreePine, Leaf, Flower2, Droplets, Sun } from "lucide-react";

const ROW_TOP = [
  { word: "Jardinerie", Icon: Sprout },
  { word: "Plantes méditerranéennes", Icon: Sun },
  { word: "Conseils experts", Icon: Sparkles },
  { word: "Click & Collect", Icon: Leaf },
  { word: "Livraison à domicile", Icon: Droplets },
  { word: "Depuis 1993", Icon: Flower2 },
];
const ROW_BOTTOM = [
  { word: "Paysagiste", Icon: TreePine },
  { word: "Création de jardin", Icon: Leaf },
  { word: "Conception 3D", Icon: Sparkles },
  { word: "Entretien régulier", Icon: Sprout },
  { word: "Élagage & taille", Icon: TreePine },
  { word: "Devis sous 48h", Icon: Flower2 },
];

function MarqueeRow({ items, direction = "left", className = "" }) {
  const seq = [...items, ...items, ...items];
  return (
    <div
      className={`jo-marquee-row ${className}`}
      data-direction={direction}
    >
      <div className="jo-marquee-track">
        {seq.map((it, i) => {
          const Ic = it.Icon;
          return (
            <span key={i} className="jo-marquee-item">
              <span className="jo-marquee-word">{it.word}</span>
              <Ic className="jo-marquee-icon" strokeWidth={2.2} />
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default function JOMarquee() {
  return (
    <section className="jo-marquee-band" data-testid="jo-marquee">
      <MarqueeRow items={ROW_TOP} direction="left" className="jo-marquee-row--top" />
      <MarqueeRow items={ROW_BOTTOM} direction="right" className="jo-marquee-row--bottom" />
    </section>
  );
}
